import { Link } from "react-router-dom";
import { COMPANY } from "@/lib/site";

export const CTABand = ({ title, subtitle }) => (
  <section className="relative border-y border-white/10 bg-[#0F0F11] noise-overlay" data-testid="cta-band">
    <div className="relative px-6 lg:px-10 py-24 grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
      <div className="lg:col-span-8">
        <div className="eyebrow mb-4">Ready when you are</div>
        <h2 className="font-display text-4xl md:text-6xl leading-[0.95] tracking-tighter">
          {title || <>Bring us your <span className="text-[#FF5722]">toughest</span> coating job.</>}
        </h2>
        {subtitle && <p className="mt-6 text-zinc-400 max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
      <div className="lg:col-span-4 flex flex-col gap-3">
        <Link to="/quote" className="btn-primary justify-between w-full" data-testid="cta-band-quote">
          Request a Quote <span>→</span>
        </Link>
        <a href={COMPANY.phoneHref} className="btn-ghost justify-between w-full" data-testid="cta-band-phone">
          Call {COMPANY.phone} <span>→</span>
        </a>
      </div>
    </div>
  </section>
);
